import { Title } from '@angular/platform-browser';
import { AcumaticaService } from 'src/app/acumatica/acumatica.service';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Directive, ElementRef, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UrlService } from './services/url.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  environment = environment;

  private currentUrl: string = '';
  private previousUrl: string = '';

  constructor(
    private router: Router,
    private titleService: Title,
    private urlService: UrlService,
    private acumatica: AcumaticaService,
  ) { }

  ngOnInit() {
    this.router.events.subscribe(event => {            
      if (event instanceof NavigationEnd) {

        // track Previous Url as user navigates application
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
        
        // Set up Google Analytics tracking
        let username = (this.acumatica.username || '').toUpperCase();
        if (username != 'NICKH') {
          //    https://blog.mestwin.net/add-google-analytics-to-angular-application-in-3-easy-steps/
          //    https://stackoverflow.com/questions/50353164/angular-6-router-events-filter-filter-does-not-exist-on-type-observableevent
          let config: any = {
            page_title: this.titleService.getTitle(),
            page_path: (<NavigationEnd>event).urlAfterRedirects,
            page_location: this.router.url,
            user_id: username
          };        
          // set parameters through 'set' and 'event' both because... ???
          Object.keys(config).forEach(key => gtag('set', key, config[key]));
          gtag('event', 'page_view', config);
        }
      }
    });
  }
}

@Directive({ selector: 'form' })
export class WMSFormDirective {
  constructor(private elementRef: ElementRef) {
    this.elementRef.nativeElement.setAttribute('autocomplete', 'off');
  }
}